import { useEffect } from 'react';

import { breakpoints, useMediaQuery } from '@coursera/cds-core';

export const useScrollToStickyBar = (isStickyBarPresent: boolean, top = 850) => {
  const isMobile = useMediaQuery(breakpoints.down('sm'));
  useEffect(() => {
    if (isMobile && isStickyBarPresent) {
      window.scrollTo({
        top,
        behavior: 'smooth',
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMobile]);
};
